import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Layout from '../Layout';
import RegisterForm from './RegisterForm2';
import {registerRequestAction, registerClearRequestFailure} from './redux2';
import { reset } from 'redux-form';
import { TooManyAttempts } from './TooManyAttempts';
@connect(
  state => {
    return {
      isFullSsnValidationRequired: state.authRoot.register.isFullSsnValidationRequired,
      blockedTimeLeft: state.authRoot.register.blockedTimeLeft,
    };
  },
  dispatch => ({
    registerRequestAction: (ssn4Digits, userName, userNameType) => dispatch(registerRequestAction(ssn4Digits, userName, userNameType)),
    clearRequestFailure: () => {
      dispatch(registerClearRequestFailure());
      dispatch(reset('register'));
    },
  })
)
class RegisterController extends React.Component {

  static propTypes = {
    registerRequestAction: PropTypes.func.isRequired,
    isFullSsnValidationRequired: PropTypes.bool,
    clearRequestFailure: PropTypes.func.isRequired,
    blockedTimeLeft: PropTypes.number,
  };

  onAgreeAndContinue(ssn4Digits, email) {
    const { registerRequestAction } = this.props;
    const userNameType = 'EMAIL';
    registerRequestAction(ssn4Digits, email, userNameType);
  }

  render() {
    if (this.props.blockedTimeLeft) {
      return (<Layout>
        <TooManyAttempts timeLeft={this.props.blockedTimeLeft} onTimerEnd={()=>this.props.clearRequestFailure()} />
      </Layout>);
    }

    return (
      <Layout>
        <RegisterForm 
          submitCallback={(ssn4Digits, email) => this.onAgreeAndContinue(ssn4Digits, email)}
          isFullSsnValidationRequired={this.props.isFullSsnValidationRequired}
        />
      </Layout>
    );
  }
}


export default RegisterController;



// WEBPACK FOOTER //
// ./src/auth/authWithOtp/RegisterController2.js